import React from "react";
import { useDispatch, useSelector } from "react-redux";
// import {
//   setNoOtherVendors,
//   setOtherVendors,
// } from "../../../../redux/slices/RequestFormSlice";
import { Label } from "reactstrap";
import Checkbox from "@mui/material/Checkbox";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import DialogContentText from "@mui/material/DialogContentText";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import {
  setNoOtherVendors,
  setOtherVendors,
} from "../../../../redux/slices/InquirySlice";

// Lazy-load MUI components
// const Box = lazy(() => import("@mui/material/Box"));
// const Grid = lazy(() => import("@mui/material/Grid"));
// const FormGroup = lazy(() => import("@mui/material/FormGroup"));
// const FormControlLabel = lazy(() => import("@mui/material/FormControlLabel"));
// const Checkbox = lazy(() => import("@mui/material/Checkbox"));
// const DialogContentText = lazy(() => import("@mui/material/DialogContentText"));

const AutoNeedOtherVendors = ({ otherVendorsError, setOtherVendorsError }) => {
  const dispatch = useDispatch();
  const { noOtherVendors, otherVendors } = useSelector(
    (state) => state.inquiry
  );

  // List of vendor options
  const vendorOptions = [
    "Photography/Videography",
    "DJ",
    "Catering",
    "Venues",
    "Hair/Makeup",
    "Tent/Table/Chairs",
    "Decorations",
    "Mehndi",
    "Jewelry",
    "Clothing",
    "Dholi",
    "Turban Tying",
    "Food cart",
    "Vehicles",
    "Cake/Desert",
    "MC",
    "Dance Floor",
    "Dance Performers",
    "Photobooth/Audio Guestbook",
    "Singer",
    "Body Beauty & Wellness",
    "Restrooms/Facility",
    "Lighting Decorations",
  ];

  // Handle vendor checkbox changes
  const handleVendorChange = (vendor) => {
    const updatedVendors = otherVendors.includes(vendor)
      ? otherVendors.filter((v) => v !== vendor)
      : [...otherVendors, vendor];
    dispatch(setOtherVendors(updatedVendors));
    setOtherVendorsError(false); // Clear error when a vendor is selected
  };
  console.log(otherVendors, "otherVendors");
  // Handle "I don't need other vendors" checkbox
  const handleNoVendorsChange = (e) => {
    dispatch(setNoOtherVendors(e.target.checked));
    if (e.target.checked) {
      dispatch(setOtherVendors([])); // Clear all vendors
    }
    setOtherVendorsError(false); // Clear error
  };

  return (
    <Box sx={{ marginTop: "20px" }}>
      <Label style={{ fontSize: "14px" }}>
        Which other vendors are you still looking for?{" "}
        <b className="text-danger">*</b>
      </Label>
      <DialogContentText sx={{ fontSize: "14px", marginBottom: "10px" }}>
        We'll instantly introduce you to all the local vendors that offer what
        you're needing.
      </DialogContentText>
      <Box
        sx={{
          maxHeight: "200px",
          overflowY: "auto",
          border: "1px solid #ccc",
          borderRadius: "4px",
          padding: "10px",
        }}
      >
        <Grid container spacing={2}>
          {vendorOptions.map((vendor, index) => (
            <Grid
              item
              xs={12}
              sm={6}
              md={4}
              key={index}
              sx={{ display: "flex", alignItems: "center" }}
            >
              <FormGroup>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={otherVendors.includes(vendor)}
                      onChange={() => handleVendorChange(vendor)}
                      disabled={noOtherVendors}
                      sx={{ padding: "4px" }}
                    />
                  }
                  label={vendor}
                  sx={{
                    margin: 0,
                    "& .MuiFormControlLabel-label": { fontSize: "14px" },
                  }}
                />
              </FormGroup>
            </Grid>
          ))}
        </Grid>
      </Box>
      <FormGroup sx={{ marginTop: "10px" }}>
        <FormControlLabel
          control={
            <Checkbox
              checked={noOtherVendors || false}
              onChange={handleNoVendorsChange}
              sx={{ padding: "4px" }}
            />
          }
          label="I don't need other vendors."
          sx={{ "& .MuiFormControlLabel-label": { fontSize: "14px" } }}
        />
      </FormGroup>
      {otherVendorsError && (
        <DialogContentText
          style={{ color: "red", fontSize: "12px", marginTop: "5px" }}
        >
          Please select at least one vendor or check "I don't need other
          vendors."
        </DialogContentText>
      )}
    </Box>
  );
};

export default AutoNeedOtherVendors;
